// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"270":"7e2064df3c9a9e34","739":"7943ae39f1ce3f7e","784":"31f2fd26fc473de8","793":"42ef63b7ec463244"}[chunkId] + ".js";
};